"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAPENFTAssetURI = exports.checkAssetBalance = exports.checkAssetApprove = exports.checkAssetAddress = exports.checkAssetMint = exports.checkOrderCancelledOrFinalized = exports.getOrderCancelledOrFinalized = exports.ordersCanMatch = exports._ordersCanMatch = exports.validateOrder = exports.checkDataToCall = exports.checkMatchOrder = exports.checkOrder = exports.checkUnhashedOrder = exports.checkApproveSchemaProxy = exports.checkApproveERC721TransferProxy = exports.checkApproveERC1155TransferProxy = exports.checkApproveTokenTransferProxy = exports.checkRegisterProxy = exports.getAccountProxyAddr = void 0;
var schemasFunctions_1 = require("../schemas/schemasFunctions");
var constants_1 = require("./constants");
var types_1 = require("../utils/types");
var helper_1 = require("./helper");
var makeOrder_1 = require("./makeOrder");
var Abi_1 = require("../utils/Abi");
var contractSchemas_1 = require("../tradeAPI/contractSchemas");
var log = console.log;
function getAccountProxyAddr(contracts, schemaName) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (schemaName === types_1.APENFTSchemaName.ERC1155) {
                return [2 /*return*/, Promise.resolve(contracts.erc1155AssetProxyAddr)];
            }
            return [2 /*return*/, Promise.resolve(contracts.erc721AssetProxyAddr)];
        });
    });
}
exports.getAccountProxyAddr = getAccountProxyAddr;
//1. check register
function checkRegisterProxy(proxyRegistryContract, account) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, true];
        });
    });
}
exports.checkRegisterProxy = checkRegisterProxy;
//2 check approve pay token
function checkApproveTokenTransferProxy(exchangeContract, erc20Contract, account) {
    return __awaiter(this, void 0, void 0, function () {
        var tokenTransferProxyAddr, allowAmount;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, exchangeContract.methods.erc20Proxy().call()];
                case 1:
                    tokenTransferProxyAddr = _a.sent();
                    return [4 /*yield*/, erc20Contract.methods.allowance(account, tokenTransferProxyAddr).call()];
                case 2:
                    allowAmount = _a.sent();
                    if (new constants_1.BigNumber(allowAmount.toString()).eq(0)) {
                        throw "Error";
                    }
                    return [2 /*return*/, true];
            }
        });
    });
}
exports.checkApproveTokenTransferProxy = checkApproveTokenTransferProxy;
function checkApproveERC1155TransferProxy(contract, nftsContract, account) {
    return __awaiter(this, void 0, void 0, function () {
        var operator, isApprove;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getAccountProxyAddr(contract, types_1.APENFTSchemaName.ERC1155)];
                case 1:
                    operator = _a.sent();
                    return [4 /*yield*/, nftsContract.methods.isApprovedForAll(account, operator).call()];
                case 2:
                    isApprove = _a.sent();
                    if (!isApprove) {
                        throw "Error";
                    }
                    return [2 /*return*/, isApprove];
            }
        });
    });
}
exports.checkApproveERC1155TransferProxy = checkApproveERC1155TransferProxy;
function checkApproveERC721TransferProxy(contract, nftsContract, account, tokenID) {
    return __awaiter(this, void 0, void 0, function () {
        var operator, isApprove;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getAccountProxyAddr(contract, types_1.APENFTSchemaName.ERC721)];
                case 1:
                    operator = _a.sent();
                    return [4 /*yield*/, nftsContract.methods.isApprovedForAll(account, operator).call()];
                case 2:
                    isApprove = _a.sent();
                    if (!isApprove) {
                        throw "Error";
                    }
                    return [2 /*return*/, true];
            }
        });
    });
}
exports.checkApproveERC721TransferProxy = checkApproveERC721TransferProxy;
function checkApproveSchemaProxy(contract, orderMetadata, account) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var operator, schemas, schema, asset, APENFTAsset, isApprove, data, rawData, callData, res, isAddr;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, getAccountProxyAddr(contract, orderMetadata.schema)];
                case 1:
                    operator = _b.sent();
                    schemas = (0, helper_1.getSchemaList)(contract.networkName, orderMetadata.schema);
                    schema = schemas[0];
                    asset = {
                        tokenId: orderMetadata.asset.id,
                        tokenAddress: orderMetadata.asset.address,
                        schemaName: orderMetadata.schema
                    };
                    APENFTAsset = (0, makeOrder_1.getAPENFTAsset)(schema, asset);
                    isApprove = (_a = schema === null || schema === void 0 ? void 0 : schema.functions) === null || _a === void 0 ? void 0 : _a.isApprove(APENFTAsset);
                    data = (0, schemasFunctions_1.encodeCall)(isApprove, [asset.tokenId]);
                    rawData = {
                        functionSelector: Abi_1.ABI.methodSig(isApprove),
                        parameters: Abi_1.ABI.paramsArray(isApprove.inputs, [asset.tokenId])
                    };
                    callData = { to: isApprove.target, data: data, rawData: rawData };
                    return [4 /*yield*/, new contractSchemas_1.ContractSchemas(null, null).tronCall.call({ web3: contract.web3 }, callData, isApprove === null || isApprove === void 0 ? void 0 : isApprove.outputs)];
                case 2:
                    res = _b.sent();
                    isAddr = isApprove === null || isApprove === void 0 ? void 0 : isApprove.outputs.some(function (val) { return val.type == 'address'; });
                    if (isAddr) {
                        res = contract.web3.address.fromHex(res) === operator;
                    }
                    if (!res) {
                        throw "Error";
                    }
                    return [2 /*return*/, res];
            }
        });
    });
}
exports.checkApproveSchemaProxy = checkApproveSchemaProxy;
function checkUnhashedOrder(contract, order) {
    return __awaiter(this, void 0, void 0, function () {
        var erc20Contract, metadata, sell, buy, assetAddress, erc20Bal, ethBal, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 11, , 12]);
                    checkAssetAddress(contract.networkName, order);
                    erc20Contract = contract.erc20.clone();
                    erc20Contract.deployed = true;
                    metadata = order.metadata;
                    if (!(order.side == types_1.OrderSide.Sell)) return [3 /*break*/, 3];
                    sell = order;
                    return [4 /*yield*/, checkAssetApprove(contract, sell)];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, checkAssetBalance(contract, sell)];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3:
                    if (!(order.side == types_1.OrderSide.Buy)) return [3 /*break*/, 10];
                    buy = order;
                    assetAddress = getAssetInfo(metadata).assetAddress;
                    if (!(assetAddress != contract.APENFTSharedAssetAddr)) return [3 /*break*/, 5];
                    return [4 /*yield*/, checkAssetMint(contract, metadata)];
                case 4:
                    _a.sent();
                    _a.label = 5;
                case 5:
                    if (!(buy.paymentToken !== constants_1.NULL_ADDRESS)) return [3 /*break*/, 8];
                    erc20Contract.address = buy.paymentToken;
                    return [4 /*yield*/, (0, helper_1.getAccountBalance)(contract.web3, buy.maker, erc20Contract)];
                case 6:
                    erc20Bal = (_a.sent()).erc20Bal;
                    if ((0, helper_1.makeBigNumber)(erc20Bal).lt(buy.basePrice))
                        throw "Error";
                    return [4 /*yield*/, checkApproveTokenTransferProxy(contract.exchange, erc20Contract, buy.maker)];
                case 7:
                    _a.sent();
                    return [3 /*break*/, 10];
                case 8: return [4 /*yield*/, (0, helper_1.getAccountBalance)(contract.web3, buy.maker)];
                case 9:
                    ethBal = (_a.sent()).ethBal;
                    if ((0, helper_1.makeBigNumber)(ethBal).lt(buy.basePrice))
                        throw "Error";
                    _a.label = 10;
                case 10:
                    checkDataToCall(contract.networkName, order);
                    return [3 /*break*/, 12];
                case 11:
                    error_1 = _a.sent();
                    if (error_1.data) {
                        error_1.data.order = order;
                    }
                    else {
                        error_1 = __assign(__assign({}, error_1), { message: error_1.message, data: { order: order } });
                    }
                    throw error_1;
                case 12: return [2 /*return*/, true];
            }
        });
    });
}
exports.checkUnhashedOrder = checkUnhashedOrder;
function checkOrder(contract, order) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, checkUnhashedOrder(contract, order)];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, checkOrderCancelledOrFinalized(contract, order)];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, validateOrder(contract.exchangeHelper, order)];
                case 3:
                    _a.sent();
                    return [2 /*return*/, true];
            }
        });
    });
}
exports.checkOrder = checkOrder;
function checkMatchOrder(contract, buy, sell) {
    return __awaiter(this, void 0, void 0, function () {
        var equalPrice;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    equalPrice = sell.basePrice.gte(buy.basePrice);
                    if (!equalPrice) {
                        throw "Error";
                    }
                    if (!_ordersCanMatch(buy, sell)) {
                        throw "Error";
                    }
                    if (!(sell.feeRecipient != constants_1.NULL_ADDRESS)) return [3 /*break*/, 3];
                    /* Assert taker fee is less than or equal to maximum fee specified by buyer. */
                    if (!sell.takerRelayerFee.lte(buy.takerRelayerFee)) {
                        throw "sell.takerRelayerFee ".concat(sell.takerRelayerFee, " <= buy.takerRelayerFee ").concat(buy.takerRelayerFee);
                    }
                    return [4 /*yield*/, checkUnhashedOrder(contract, buy)];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, checkOrder(contract, sell)];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 6];
                case 3:
                    /* Assert taker fee is less than or equal to maximum fee specified by seller. */
                    if (!buy.takerRelayerFee.lte(sell.takerRelayerFee)) {
                        throw "buy.takerRelayerFee ".concat(buy.takerRelayerFee, " <= sell.takerRelayerFee ").concat(sell.takerRelayerFee);
                    }
                    return [4 /*yield*/, checkUnhashedOrder(contract, sell)];
                case 4:
                    _a.sent();
                    return [4 /*yield*/, checkOrder(contract, buy)];
                case 5:
                    _a.sent();
                    _a.label = 6;
                case 6: return [2 /*return*/, true];
            }
        });
    });
}
exports.checkMatchOrder = checkMatchOrder;
function checkDataToCall(netWorkName, order) {
    var schemas = (0, helper_1.getSchemaList)(netWorkName, order.metadata.schema);
    // TODO data sell.metadata.asset
    var asset = order.metadata.asset;
    if (!asset.data && asset.schemaName === types_1.APENFTSchemaName.ERC1155) {
        asset = __assign(__assign({}, asset), { data: '' });
    }
    var encodeData;
    if (order.side == types_1.OrderSide.Sell) {
        encodeData = (0, schemasFunctions_1.encodeSell)(schemas[0], asset, order.maker);
    }
    else {
        encodeData = (0, schemasFunctions_1.encodeBuy)(schemas[0], asset, order.maker);
    }
    if (encodeData.dataToCall != order.dataToCall) {
        throw "Error: dataToCall";
    }
    if (encodeData.target != order.target) {
        throw "Error: target";
    }
    if (encodeData.replacementPattern != order.replacementPattern) {
        throw "Error: replacementPattern";
    }
}
exports.checkDataToCall = checkDataToCall;
function validateOrder(exchangeHelper, order) {
    return __awaiter(this, void 0, void 0, function () {
        var orderParamValueArray, orderSigArray, isValidate, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    orderParamValueArray = (0, helper_1.orderParamsEncode)(order);
                    orderSigArray = (0, helper_1.orderSigEncode)(order);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, exchangeHelper.methods.validateOrder(orderParamValueArray, orderSigArray).call()];
                case 2:
                    isValidate = _a.sent();
                    if (!isValidate) {
                        throw "Error";
                    }
                    return [2 /*return*/, isValidate];
                case 3:
                    e_1 = _a.sent();
                    if (!e_1.code) {
                        throw "Error";
                    }
                    throw e_1;
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.validateOrder = validateOrder;
var canSettleOrder = function (listingTime, expirationTime) {
    var now = Math.round(Date.now() / 1000);
    if (constants_1.BigNumber.isBigNumber(listingTime)) {
        listingTime = listingTime.toNumber();
    }
    else {
        listingTime = Number(listingTime);
    }
    if (constants_1.BigNumber.isBigNumber(expirationTime)) {
        expirationTime = expirationTime.toNumber();
    }
    else {
        expirationTime = Number(expirationTime);
    }
    var canSettle = listingTime <= now && (expirationTime == 0 || now < expirationTime);
    return canSettle;
};
function _ordersCanMatch(buy, sell) {
    var errorLog = function (msg) {
        return false;
    };
    return ((buy.side == 0 || errorLog('buy.side')) &&
        (sell.side == 1 || errorLog('sell.side')) &&
        /* Must use same fee method. */
        (buy.feeMethod == sell.feeMethod || errorLog('feeMethod !=')) &&
        /* Must use same payment token. */
        (buy.paymentToken == sell.paymentToken || errorLog('paymentToken !=')) &&
        /* Must match maker/taker addresses. */
        (sell.taker == constants_1.NULL_ADDRESS || sell.taker == buy.maker || errorLog('sell.taker != buy.maker')) &&
        (buy.taker == constants_1.NULL_ADDRESS || buy.taker == sell.maker || errorLog('buy.taker != sell.maker')) &&
        /* One must be maker and the other must be taker (no bool XOR in Solidity). */
        ((sell.feeRecipient == constants_1.NULL_ADDRESS && buy.feeRecipient != constants_1.NULL_ADDRESS) ||
            (sell.feeRecipient != constants_1.NULL_ADDRESS && buy.feeRecipient == constants_1.NULL_ADDRESS)) &&
        /* Must match target. */
        (buy.target == sell.target || errorLog('target != ')) &&
        /* Must match howToCall. */
        (buy.howToCall == sell.howToCall || errorLog('howToCall != ')) &&
        /* Buy-side order must be settleable. */
        (canSettleOrder(buy.listingTime, buy.expirationTime) || errorLog("buy.expirationTime != ")) &&
        /* Sell-side order must be settleable. */
        (canSettleOrder(sell.listingTime, sell.expirationTime) || errorLog("sell.expirationTime != ")));
}
exports._ordersCanMatch = _ordersCanMatch;
function ordersCanMatch(exchangeHelper, buy, sell) {
    return __awaiter(this, void 0, void 0, function () {
        var buyOrderParamArray, sellOrderParamArray, canMatch;
        return __generator(this, function (_a) {
            buyOrderParamArray = (0, helper_1.orderParamsEncode)(buy);
            sellOrderParamArray = (0, helper_1.orderParamsEncode)(sell);
            canMatch = exchangeHelper.methods.ordersCanMatch(buyOrderParamArray, sellOrderParamArray).call();
            if (!canMatch) {
                throw "Error";
            }
            return [2 /*return*/, true];
        });
    });
}
exports.ordersCanMatch = ordersCanMatch;
function getOrderCancelledOrFinalized(contract, order) {
    return __awaiter(this, void 0, void 0, function () {
        var orderParamValueArray, hash;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    orderParamValueArray = (0, helper_1.orderParamsEncode)(order);
                    return [4 /*yield*/, contract.exchangeHelper.methods.hashToSign(orderParamValueArray).call()];
                case 1:
                    hash = _a.sent();
                    return [2 /*return*/, contract.exchange.methods.cancelledOrFinalized(hash).call()];
            }
        });
    });
}
exports.getOrderCancelledOrFinalized = getOrderCancelledOrFinalized;
function checkOrderCancelledOrFinalized(contract, order) {
    return __awaiter(this, void 0, void 0, function () {
        var isCancelledOrFinalized;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getOrderCancelledOrFinalized(contract, order)];
                case 1:
                    isCancelledOrFinalized = _a.sent();
                    if (isCancelledOrFinalized) {
                        if (order.side === types_1.OrderSide.Sell) {
                            throw "Error: Sell";
                        }
                        else {
                            throw "Error: Buy";
                        }
                    }
                    return [2 /*return*/];
            }
        });
    });
}
exports.checkOrderCancelledOrFinalized = checkOrderCancelledOrFinalized;
function getAssetInfo(metadata) {
    var tokenId;
    var assetAddress;
    if (metadata.asset.id && metadata.asset.address) {
        tokenId = metadata.asset.id;
        assetAddress = metadata.asset.address;
    }
    else {
        throw "Error: sell.metadata.asset.id or address undefined";
    }
    return { tokenId: tokenId, assetAddress: assetAddress };
}
function checkAssetMint(contract, metadata) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, tokenId, assetAddress;
        return __generator(this, function (_b) {
            _a = getAssetInfo(metadata), tokenId = _a.tokenId, assetAddress = _a.assetAddress;
            return [2 /*return*/, true];
        });
    });
}
exports.checkAssetMint = checkAssetMint;
function checkAssetAddress(netWorkName, order) {
    return __awaiter(this, void 0, void 0, function () {
        var schemas, metadata, assetAddress;
        return __generator(this, function (_a) {
            schemas = (0, helper_1.getSchemaList)(netWorkName, order.metadata.schema);
            metadata = order.metadata;
            assetAddress = getAssetInfo(metadata).assetAddress;
            if (schemas.length === 0) {
                throw "Error";
            }
            return [2 /*return*/];
        });
    });
}
exports.checkAssetAddress = checkAssetAddress;
function checkAssetApprove(contract, order) {
    return __awaiter(this, void 0, void 0, function () {
        var sell, checkAddr, metadata, _a, tokenId, assetAddress, sellNFTs, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    sell = order;
                    checkAddr = sell.maker;
                    metadata = sell.metadata;
                    _a = getAssetInfo(metadata), tokenId = _a.tokenId, assetAddress = _a.assetAddress;
                    sellNFTs = contract.erc20.clone();
                    sellNFTs.deployed = true;
                    _b = metadata.schema;
                    switch (_b) {
                        case types_1.APENFTSchemaName.ERC20: return [3 /*break*/, 1];
                        case types_1.APENFTSchemaName.ERC721: return [3 /*break*/, 2];
                        case types_1.APENFTSchemaName.ERC1155: return [3 /*break*/, 4];
                    }
                    return [3 /*break*/, 8];
                case 1:
                    sellNFTs = contract.erc20.clone();
                    sellNFTs.address = assetAddress;
                    sellNFTs.deployed = true;
                    return [3 /*break*/, 10];
                case 2:
                    sellNFTs = contract.erc721.clone();
                    sellNFTs.address = assetAddress;
                    sellNFTs.deployed = true;
                    return [4 /*yield*/, checkApproveERC721TransferProxy(contract, sellNFTs, checkAddr, tokenId)];
                case 3:
                    _c.sent();
                    return [3 /*break*/, 10];
                case 4:
                    sellNFTs = contract.erc1155.clone();
                    sellNFTs.address = assetAddress;
                    sellNFTs.deployed = true;
                    if (!(assetAddress != contract.APENFTSharedAssetAddr)) return [3 /*break*/, 6];
                    return [4 /*yield*/, checkAssetMint(contract, metadata)];
                case 5:
                    _c.sent();
                    _c.label = 6;
                case 6: return [4 /*yield*/, checkApproveERC1155TransferProxy(contract, sellNFTs, checkAddr)];
                case 7:
                    _c.sent();
                    return [3 /*break*/, 10];
                case 8: return [4 /*yield*/, checkApproveSchemaProxy(contract, metadata, checkAddr)];
                case 9:
                    _c.sent();
                    return [3 /*break*/, 10];
                case 10: return [2 /*return*/, sellNFTs];
            }
        });
    });
}
exports.checkAssetApprove = checkAssetApprove;
function checkAssetBalance(contract, order) {
    return __awaiter(this, void 0, void 0, function () {
        var checkAddr, metadata, _a, tokenId, assetAddress, sellNFTs, balance, _b, owner, checkAddrHex;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    checkAddr = order.maker;
                    metadata = order.metadata;
                    _a = getAssetInfo(metadata), tokenId = _a.tokenId, assetAddress = _a.assetAddress;
                    sellNFTs = contract.erc20.clone();
                    sellNFTs.deployed = true;
                    balance = 0;
                    _b = metadata.schema;
                    switch (_b) {
                        case types_1.APENFTSchemaName.ERC20: return [3 /*break*/, 1];
                        case types_1.APENFTSchemaName.ERC721: return [3 /*break*/, 2];
                        case types_1.APENFTSchemaName.ERC1155: return [3 /*break*/, 4];
                    }
                    return [3 /*break*/, 6];
                case 1:
                    sellNFTs = contract.erc20.clone();
                    sellNFTs.address = assetAddress;
                    sellNFTs.deployed = true;
                    return [3 /*break*/, 7];
                case 2:
                    sellNFTs = contract.erc721.clone();
                    sellNFTs.address = assetAddress;
                    sellNFTs.deployed = true;
                    return [4 /*yield*/, sellNFTs.methods.ownerOf(tokenId).call()];
                case 3:
                    owner = _c.sent();
                    checkAddrHex = contract.web3.address.toHex(checkAddr);
                    if (owner !== checkAddrHex)
                        throw "Error";
                    balance = 1;
                    return [3 /*break*/, 7];
                case 4:
                    sellNFTs = contract.erc1155.clone();
                    sellNFTs.address = assetAddress;
                    sellNFTs.deployed = true;
                    return [4 /*yield*/, sellNFTs.methods.balanceOf(checkAddr, tokenId).call()];
                case 5:
                    balance = _c.sent();
                    return [3 /*break*/, 7];
                case 6: throw "Error";
                case 7:
                    if (!constants_1.BigNumber.isBigNumber(order.quantity)) {
                        order.quantity = new constants_1.BigNumber(order.quantity);
                    }
                    if (order.quantity.gt(balance.toString())) {
                        throw "Error";
                    }
                    return [2 /*return*/, Number(balance)];
            }
        });
    });
}
exports.checkAssetBalance = checkAssetBalance;
var getAPENFTAssetURI = function (contract, tokenId) { return __awaiter(void 0, void 0, void 0, function () {
    var overURI, URI;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, contract.APENFTSharedAsset.methods._getOverrideURI(tokenId).call()];
            case 1:
                overURI = _a.sent();
                return [4 /*yield*/, contract.APENFTSharedAsset.methods.uri(tokenId).call()];
            case 2:
                URI = _a.sent();
                return [2 /*return*/, { overURI: overURI, URI: URI }];
        }
    });
}); };
exports.getAPENFTAssetURI = getAPENFTAssetURI;
